import WhatsAppIcon from '@mui/icons-material/WhatsApp';
import MailOutlineIcon from '@mui/icons-material/MailOutline';
import InstagramIcon from '@mui/icons-material/Instagram';
import FacebookIcon from '@mui/icons-material/Facebook';
import YoutubeIcon from '@mui/icons-material/YouTube';

import logografico from './../assets/images/logo_vidaplus_transparente_200x60.png'


interface FooterProps {
    id: string;
}

const Footer: React.FC<FooterProps> = ({ id }) => {
    return (
        <div id={id} className="">
            <div className="flex flex-col justify-center items-center bg-white pt-2 border-t border-stone-300 flex-grow">
                <div className="flex flex-col mx-6 justify-evenly items-center w-full md:flex-row">
                    {/* Logo grande */}
                    <div className="flex-col flex justify-center items-center group">
                        <img src={logografico} className="max-h-[40px] min-w-[140px] group-hover:drop-shadow-lg group-hover:shadow-vp-gris group-hover:scale-110 transition" alt="VidaPlus Logo" />
                    </div>
                    {/* Email */}
                    <div className="flex mt-2 flex-col justify-center items-center md:mt-0">
                        <div className="flex flex-row justify-center items-center group">
                            <a href="https://wa.me/5493415779225" target="_blank" rel="noreferrer" className="flex flex-row">
                                <div className="flex flex-col justify-center items-center rounded-full p-1 group-hover:shadow-md group-hover:shadow-vp-gris group-hover:scale-110 transition">
                                    <MailOutlineIcon  className="text-vp-gris" />
                                </div>
                                <div className="flex flex-col justify-center items-center">
                                    <p className="font-myriad-pro text-vp-gris font-regular">contacto@vidaplus.com.ar</p>
                                </div>
                            </a>
                        </div>
                    </div>
                    {/* Whatsapp */}
                    <div className="flex flex-col justify-center items-center">
                        <div className="flex flex-row justify-center items-center group">
                            <a href="https://wa.me/5493415779225" target="_blank" rel="noreferrer" className="flex flex-row">
                                <div className="flex flex-col justify-center items-center rounded-full p-1 group-hover:shadow-md group-hover:shadow-vp-gris group-hover:scale-110 transition">
                                    <WhatsAppIcon  className="text-vp-gris" />
                                </div>
                                <div className="flex flex-col justify-center items-center">
                                    <p className="font-myriad-pro text-vp-gris font-regular">+54 9 341 577-9225</p>
                                </div>
                            </a>
                        </div>
                    </div>
                    {/* Seguinos en nuestras redes */}
                    <div className="flex flex-col justify-center items-center my-2 md:my-0">
                        <div className="flex flex-row justify-center items-center rounded-full ">
                            <div className="hidden flex-col justify-center items-center md:flex">
                                <h4 className="font-myriad-pro text-vp-gris font-regular mr-3">Seguinos en nuestras redes</h4>
                            </div>
                            <div className="flex flex-col justify-center items-center group mr-2">
                                <a href="https://www.instagram.com/vidaplus.ar?igsh=Zm15anBhc3k0dzBi" target="_blank" rel="noreferrer">
                                    <div className="text-center rounded-full p-2 bg-white shadow-lg shadow-vp-gris group-hover:scale-110 transition">
                                        <InstagramIcon className="text-vp-gris" />
                                    </div>
                                </a>
                            </div>
                            <div className="flex flex-col justify-center items-center group mr-2">
                                <a href="https://www.facebook.com/share/15hzijgbsK/?mibextid=wwXIfr" target="_blank" rel="noreferrer">
                                    <div className="text-center rounded-full p-2 bg-white shadow-lg shadow-vp-gris group-hover:scale-110 transition">
                                        <FacebookIcon className="text-vp-gris" />
                                    </div>
                                </a>
                            </div>
                            <div className="flex flex-col justify-center items-center group">
                                <a href="https://www.youtube.com/@vidaplus-salud" target="_blank" rel="noreferrer">
                                    <div className="text-center rounded-full p-2 bg-white shadow-lg shadow-vp-gris group-hover:scale-110 transition">
                                        <YoutubeIcon className="text-vp-gris" />
                                    </div>
                                </a>
                            </div>
                        </div>
                    </div>
                </div>
                {/* Todos los derechos reservados */}
                <div className="flex flex-col sm:flex-row justify-start items-center mt-1">
                    <h4 className="font-myriad-pro text-vp-gris font-regular ">Todos los derechos reservados.</h4>
                </div> 
                {/* Sitio desarrollado por SecureNetwork S.A. */}
                <div className="flex flex-col sm:flex-row justify-center flex-wrap items-center mt-1">
                    <div className="flex flex-row justify-center items-center xxs:flex-col">
                        <h4 className="font-myriad-pro text-vp-gris font-regular mt-3 mb-2 mr-2">Sitio desarrollado por: </h4>
                        <a href="https://www.securenetwork.com.ar" target="_blank" rel="noreferrer" className="font-myriad-pro text-vp-gris font-bold underline">SecureNetwork S.A.</a>
                    </div>
                </div> 
            </div>
        </div>
    );
};

export default Footer;